/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneSchemaMarkup from 'base/components/standalone/SchemaMarkup';

export const DynamicStandaloneSchemaMarkup = StandaloneSchemaMarkup;
export type DynamicStandaloneSchemaMarkupProps = PropsFromComponent<typeof StandaloneSchemaMarkup>;

export const DynamicStandaloneSchemaMarkupWith = (extras: DynamicStandaloneExtras): typeof StandaloneSchemaMarkup => {
    return function DynamicStandaloneSchemaMarkup(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'SchemaMarkup');
        return <StandaloneSchemaMarkup {...mergeProps({ options: { theme } }, props)} />;
    }
}